import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { ApplicationHttpClient, applicationHttpClientCreator } from '@base/http-client';
import { MaterialModule } from './../material';
import { AuthRoutingModule } from '@auth/auth-routing.module';
import { LoginComponent } from '@auth/login/login.component';
import { RecoverComponent } from '@auth/recover/recover.component';
import { ResetPasswordComponent } from '@auth/reset-password/reset-password.component';
import { AuthService } from './auth.service';
import { AppService } from '@base/app.service';
import { ServerDownComponent } from '@base/server-down/server-down.component';

@NgModule({
  declarations: [
    LoginComponent,
    RecoverComponent,
    ResetPasswordComponent,
    ServerDownComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRoutingModule,
  ],
  providers: [
    AppService,
    {
      provide: ApplicationHttpClient,
      useFactory: applicationHttpClientCreator,
      deps: [HttpClient]
    },
    AuthService,
  ],
})
export class AuthModule { }
